import { connect } from 'react-redux'
import { branch, compose, renderNothing } from 'recompose'
import { injectIntl } from 'react-intl'
import {
  withAdditionalInfoToggle,
  withEventOnceOnMount,
  withElementRef
} from 'src/composables'
import {
  selectCustomerPhone,
  selectCustomerProfile,
  selectCustomerEmail
} from 'src/store/selectors/customerProfile'
import {
  selectEquityPercent,
  selectShowReverseMortgage
} from 'src/store/selectors/home/reverseMortgage'
import { ModuleShown, EVENTS_LABELS } from 'src/constants/trackingEvents'
import { ReverseMortgagesPanel } from 'src/constants/notificationRefs'

const ReverseMortgagesPanelContainer = compose(
  connect(state => ({
    equityPercent: selectEquityPercent(state) || 0,
    show: selectShowReverseMortgage(state),
    customerProfile: selectCustomerProfile(state) || {},
    phone: selectCustomerPhone(state),
    email: selectCustomerEmail(state)
  })),
  branch(({ show }) => !show, renderNothing),
  injectIntl,
  withAdditionalInfoToggle,
  withElementRef(ReverseMortgagesPanel),
  withEventOnceOnMount(ModuleShown, {
    eventLabel: EVENTS_LABELS.ReverseMortgageSection
  })
)

export default ReverseMortgagesPanelContainer
